export function stonlyTrackFn(userId,customPropObj){
    stonlyTrack('identify', userId , customPropObj);
}
